import React from "react";
import { useFormik } from "formik";
import FormButtons from "../../../Molecule/Buttons/FormButtons";
import { CustomModal } from "../../../Atom/Modals";

const LinkModal = ({
	linkModal,
	setLinkModal,
	setHyperLink,
	prevHREF,
	prevNewTab
}) => {
	const formik = useFormik({
		initialValues: {
			href: prevHREF || "",
			newTab: prevNewTab === "_blank" ? true : false
		},
		validate: values => {
			const errors = {};
			if (!isValidUrl(values.href)) errors.href = "Please enter a valid URL";
			return errors;
		},
		onSubmit: values => {
			setHyperLink(values.href, values.newTab);
			setLinkModal(false);
		},
		enableReinitialize: true
	});

	const isValidUrl = url => {
		try {
			url = new URL(url);
		} catch (e) {
			return false;
		}
		return url.protocol === "http:" || url.protocol === "https:";
	};

	const onCloseModal = openModal => {
		setLinkModal(openModal);
	};

	return (
		<div>
			<CustomModal
				width="50%"
				overflow="scroll"
				openModal={linkModal}
				setOpenModal={onCloseModal}
				header={"Add Hyper Link"}
				content={
					<>
						<div className="row px-3">
							<div className="col-12 col-md-12 col-lg-12 mb-3">
								<label className="label" htmlFor="session_title">
									URL<span className="text-danger"> *</span>
								</label>
								<div className="">
									<input
										type="text"
										className={
											formik.errors["href"] && formik.touched.href
												? "input border-danger box-shawdow-none"
												: "input"
										}
										onBlur={formik.handleBlur}
										id="link-href"
										placeholder="Enter URL"
										value={formik.values.href}
										onChange={e => formik.setFieldValue("href", e.target.value)}
									/>
								</div>
								{formik.errors["href"] && formik.touched.href && (
									<p className="text-danger pt-1">{formik.errors.href}</p>
								)}
								<div className="mb-2 mt-2">
									<input
										className="mr-2"
										type="checkbox"
										id="sponsor-cat"
										checked={formik.values.newTab}
										onClick={e =>
											formik.setFieldValue("newTab", e.target.checked)
										}
									/>
									<label for="sponsor-cat">Open link in new tab.</label>
								</div>
							</div>
						</div>
						<FormButtons
							saveBtnContent={"Add"}
							saveBtnDisabled={!formik.dirty}
							cancelBtnContent="Close"
							onSave={() => formik.submitForm()}
							onCancel={() => onCloseModal(false)}
						/>
					</>
				}
			/>
		</div>
	);
};

export default LinkModal;
